// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Landing.css - Clean, Light and Professional Aesthetic */
:root {
  --primary: #2563eb;
  --bg-main: #ffffff;
  --bg-soft: #f8fafc;
  --yellow-main: #fca311;
  --yellow-hover: #ffb703;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --border: #e2e8f0;
  --glass-bg: rgba(255, 255, 255, 0.8);
  --glass-border: rgba(226, 232, 240, 0.5);
}

body, html {
  margin: 0;
  padding: 0;
  font-family: 'Outfit', -apple-system, sans-serif;
  background-color: var(--bg-main);
  color: var(--text-primary);
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
}

.landing-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Header */
.landing-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--border);
}

.landing-logo-placeholder {
  width: 50px;
  height: 50px;
  background: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 800;
  border-radius: 12px;
  text-transform: uppercase;
}

.landing-nav a {
  color: var(--text-secondary);
  text-decoration: none;
  margin-left: 2rem;
  font-weight: 600;
  transition: color 0.3s;
}

.landing-nav a:hover {
  color: var(--primary);
}

/* Hero Section */
.landing-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6rem 5%;
  min-height: 80vh;
  background: radial-gradient(circle at 10% 20%, rgba(37, 99, 235, 0.05) 0%, transparent 50%);
}

.hero-content {
  flex: 1 1;
  max-width: 600px;
  z-index: 2;
}

.badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: var(--primary-light);
  color: var(--primary);
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  border: 1px solid rgba(37, 99, 235, 0.1);
}

.hero-content h1 {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.1;
  margin: 0 0 1.5rem;
  color: var(--text-primary);
  letter-spacing: -2px;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 2.5rem;
}

.hero-actions {
  display: flex;
  gap: 1rem;
}

.btn-primary-glow {
  background: var(--primary);
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
  transition: all 0.3s ease;
}

.btn-primary-glow:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(37, 99, 235, 0.3);
}

.btn-secondary {
  background: white;
  color: var(--text-primary);
  border: 1px solid var(--border);
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: all 0.3s;
}

.btn-secondary:hover {
  background: #f1f5f9;
  border-color: var(--text-secondary);
}

/* Abstract Hero Image */
.hero-image-placeholder {
  flex: 1 1;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.abstract-car {
  width: 450px;
  height: 450px;
  border-radius: 60px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);
  transform: rotate(5deg);
}

.car-glow {
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.1) 0%, transparent 70%);
  filter: blur(20px);
}

.car-line {
  position: absolute;
  width: 350px;
  height: 4px;
  background: linear-gradient(90deg, transparent, var(--primary), transparent);
  transform: rotate(-15deg);
  box-shadow: 0 0 20px rgba(37, 99, 235, 0.4);
  animation: pulse 2s infinite alternate;
}

/* Services */
.landing-services {
  padding: 6rem 5%;
  background: var(--bg-soft);
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 4rem;
  color: var(--text-primary);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
}

.service-card {
  background: var(--bg-main);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 2.5rem;
  transition: all 0.3s;
  box-shadow: 0 4px 6px rgba(0,0,0,0.02);
}

.service-card:hover {
  transform: translateY(-8px);
  border-color: var(--primary);
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);
}

.service-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  display: block;
}

.service-card h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.service-card p {
  color: var(--text-secondary);
  line-height: 1.6;
}

.service-card .price {
  margin-top: 2rem;
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--primary);
}

/* AI Banner */
.landing-ai-banner {
  padding: 5rem 5%;
  background: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  overflow: hidden;
}

.ai-content h2 {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 1rem;
}

.ai-content p {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  max-width: 500px;
  line-height: 1.6;
}

.ai-illustration {
  font-size: 8rem;
  filter: drop-shadow(0 0 30px rgba(0,0,0,0.2));
  animation: float 3s ease-in-out infinite;
}

/* Info Section */
.landing-info-section {
  padding: 8rem 5%;
  display: flex;
  gap: 2rem;
  justify-content: center;
  background: var(--bg-main);
}

.info-box {
  background: var(--bg-soft);
  padding: 3rem;
  border-radius: 32px;
  border: 1px solid var(--border);
  flex: 1 1;
  max-width: 400px;
  text-align: center;
  transition: all 0.3s;
}

.info-box:hover {
  background: white;
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);
}

.info-box h3 {
  font-size: 1.75rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  color: var(--primary);
}

.info-box p {
  color: var(--text-secondary);
  line-height: 1.8;
  font-size: 1.1rem;
}

/* Footer */
.landing-footer {
  text-align: center;
  padding: 3rem;
  background: var(--bg-soft);
  color: var(--text-secondary);
  border-top: 1px solid var(--border);
  font-weight: 500;
}

/* Modals - Clean Style */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 3.5rem;
  border-radius: 32px;
  border: 1px solid var(--border);
  text-align: center;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 40px 100px rgba(0,0,0,0.1);
}

.modal-content h2 {
  font-size: 2rem;
  font-weight: 800;
  margin-top: 0;
  color: var(--primary);
  margin-bottom: 1.5rem;
}

.modal-content p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 2.5rem;
  font-size: 1.1rem;
}

.btn-whatsapp {
  background: #22c55e;
  color: white;
  border: none;
  padding: 1.25rem 2.5rem;
  font-size: 1.2rem;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 700;
  box-shadow: 0 10px 20px rgba(34, 197, 94, 0.2);
  transition: all 0.3s;
}

.btn-whatsapp:hover {
  background: #16a34a;
  transform: scale(1.02);
}

.btn-close {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  margin-top: 2rem;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
}

/* Animations */
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
}

@keyframes pulse {
  from { opacity: 0.6; transform: scale(1) rotate(-15deg); }
  to { opacity: 1; transform: scale(1.05) rotate(-15deg); }
}

.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out forwards;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

`, "",{"version":3,"sources":["webpack://./src/Landing.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gDAAgD;EAChD,gCAAgC;EAChC,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EAEpC,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,2FAA2F;AAC7F;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,4EAA4E;EAC5E,yBAAyB;EACzB,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,KAAK,0BAA0B,EAAE;EACjC,MAAM,4BAA4B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,OAAO,YAAY,EAAE,kCAAkC,EAAE;EACzD,KAAK,UAAU,EAAE,qCAAqC,EAAE;AAC1D;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":["/* Landing.css - Clean, Light and Professional Aesthetic */\n:root {\n  --primary: #2563eb;\n  --bg-main: #ffffff;\n  --bg-soft: #f8fafc;\n  --yellow-main: #fca311;\n  --yellow-hover: #ffb703;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --border: #e2e8f0;\n  --glass-bg: rgba(255, 255, 255, 0.8);\n  --glass-border: rgba(226, 232, 240, 0.5);\n}\n\nbody, html {\n  margin: 0;\n  padding: 0;\n  font-family: 'Outfit', -apple-system, sans-serif;\n  background-color: var(--bg-main);\n  color: var(--text-primary);\n  scroll-behavior: smooth;\n  -webkit-font-smoothing: antialiased;\n}\n\n.landing-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Header */\n.landing-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 5%;\n  background: rgba(255, 255, 255, 0.9);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  border-bottom: 1px solid var(--border);\n}\n\n.landing-logo-placeholder {\n  width: 50px;\n  height: 50px;\n  background: var(--primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 800;\n  border-radius: 12px;\n  text-transform: uppercase;\n}\n\n.landing-nav a {\n  color: var(--text-secondary);\n  text-decoration: none;\n  margin-left: 2rem;\n  font-weight: 600;\n  transition: color 0.3s;\n}\n\n.landing-nav a:hover {\n  color: var(--primary);\n}\n\n/* Hero Section */\n.landing-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6rem 5%;\n  min-height: 80vh;\n  background: radial-gradient(circle at 10% 20%, rgba(37, 99, 235, 0.05) 0%, transparent 50%);\n}\n\n.hero-content {\n  flex: 1;\n  max-width: 600px;\n  z-index: 2;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  background: var(--primary-light);\n  color: var(--primary);\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  border: 1px solid rgba(37, 99, 235, 0.1);\n}\n\n.hero-content h1 {\n  font-size: 4rem;\n  font-weight: 800;\n  line-height: 1.1;\n  margin: 0 0 1.5rem;\n  color: var(--text-primary);\n  letter-spacing: -2px;\n}\n\n.hero-subtitle {\n  font-size: 1.25rem;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 2.5rem;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.btn-primary-glow {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);\n  transition: all 0.3s ease;\n}\n\n.btn-primary-glow:hover {\n  background: #1d4ed8;\n  transform: translateY(-2px);\n  box-shadow: 0 15px 30px rgba(37, 99, 235, 0.3);\n}\n\n.btn-secondary {\n  background: white;\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-radius: 12px;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.3s;\n}\n\n.btn-secondary:hover {\n  background: #f1f5f9;\n  border-color: var(--text-secondary);\n}\n\n/* Abstract Hero Image */\n.hero-image-placeholder {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n\n.abstract-car {\n  width: 450px;\n  height: 450px;\n  border-radius: 60px;\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border);\n  box-shadow: 0 20px 40px rgba(0,0,0,0.05);\n  transform: rotate(5deg);\n}\n\n.car-glow {\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, rgba(37, 99, 235, 0.1) 0%, transparent 70%);\n  filter: blur(20px);\n}\n\n.car-line {\n  position: absolute;\n  width: 350px;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, var(--primary), transparent);\n  transform: rotate(-15deg);\n  box-shadow: 0 0 20px rgba(37, 99, 235, 0.4);\n  animation: pulse 2s infinite alternate;\n}\n\n/* Services */\n.landing-services {\n  padding: 6rem 5%;\n  background: var(--bg-soft);\n}\n\n.section-title {\n  text-align: center;\n  font-size: 2.5rem;\n  font-weight: 800;\n  margin-bottom: 4rem;\n  color: var(--text-primary);\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.service-card {\n  background: var(--bg-main);\n  border: 1px solid var(--border);\n  border-radius: 24px;\n  padding: 2.5rem;\n  transition: all 0.3s;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.02);\n}\n\n.service-card:hover {\n  transform: translateY(-8px);\n  border-color: var(--primary);\n  box-shadow: 0 20px 40px rgba(0,0,0,0.05);\n}\n\n.service-icon {\n  font-size: 3rem;\n  margin-bottom: 1.5rem;\n  display: block;\n}\n\n.service-card h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.service-card p {\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n.service-card .price {\n  margin-top: 2rem;\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--primary);\n}\n\n/* AI Banner */\n.landing-ai-banner {\n  padding: 5rem 5%;\n  background: var(--primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  position: relative;\n  overflow: hidden;\n}\n\n.ai-content h2 {\n  font-size: 3rem;\n  font-weight: 800;\n  margin-bottom: 1rem;\n}\n\n.ai-content p {\n  font-size: 1.25rem;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 500px;\n  line-height: 1.6;\n}\n\n.ai-illustration {\n  font-size: 8rem;\n  filter: drop-shadow(0 0 30px rgba(0,0,0,0.2));\n  animation: float 3s ease-in-out infinite;\n}\n\n/* Info Section */\n.landing-info-section {\n  padding: 8rem 5%;\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  background: var(--bg-main);\n}\n\n.info-box {\n  background: var(--bg-soft);\n  padding: 3rem;\n  border-radius: 32px;\n  border: 1px solid var(--border);\n  flex: 1;\n  max-width: 400px;\n  text-align: center;\n  transition: all 0.3s;\n}\n\n.info-box:hover {\n  background: white;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.05);\n}\n\n.info-box h3 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  margin-bottom: 1.5rem;\n  color: var(--primary);\n}\n\n.info-box p {\n  color: var(--text-secondary);\n  line-height: 1.8;\n  font-size: 1.1rem;\n}\n\n/* Footer */\n.landing-footer {\n  text-align: center;\n  padding: 3rem;\n  background: var(--bg-soft);\n  color: var(--text-secondary);\n  border-top: 1px solid var(--border);\n  font-weight: 500;\n}\n\n/* Modals - Clean Style */\n.modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 3.5rem;\n  border-radius: 32px;\n  border: 1px solid var(--border);\n  text-align: center;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 40px 100px rgba(0,0,0,0.1);\n}\n\n.modal-content h2 {\n  font-size: 2rem;\n  font-weight: 800;\n  margin-top: 0;\n  color: var(--primary);\n  margin-bottom: 1.5rem;\n}\n\n.modal-content p {\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 2.5rem;\n  font-size: 1.1rem;\n}\n\n.btn-whatsapp {\n  background: #22c55e;\n  color: white;\n  border: none;\n  padding: 1.25rem 2.5rem;\n  font-size: 1.2rem;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 700;\n  box-shadow: 0 10px 20px rgba(34, 197, 94, 0.2);\n  transition: all 0.3s;\n}\n\n.btn-whatsapp:hover {\n  background: #16a34a;\n  transform: scale(1.02);\n}\n\n.btn-close {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  margin-top: 2rem;\n  cursor: pointer;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n/* Animations */\n@keyframes float {\n  0% { transform: translateY(0px); }\n  50% { transform: translateY(-15px); }\n  100% { transform: translateY(0px); }\n}\n\n@keyframes pulse {\n  from { opacity: 0.6; transform: scale(1) rotate(-15deg); }\n  to { opacity: 1; transform: scale(1.05) rotate(-15deg); }\n}\n\n.animate-fade-in-up {\n  animation: fadeInUp 0.6s ease-out forwards;\n}\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
